import { Link, useLocation } from 'react-router-dom';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { CardHeader } from 'components/common';
import { ArrowLeft, DeleteIcon } from 'icons';

import { CompensationBreadcrumbs, CompensationBreadcrumbsProps } from './CompensationBreadcrumbs';
import { EditorButtons } from '../SettingsPage';
import { CompensationEditMode } from '../Details/enums';
import styles from './CompensationHeader.module.scss';

interface Props {
  readonly breadcrumbs: CompensationBreadcrumbsProps;
  readonly isEditMode: boolean;
  readonly availableEditMode: CompensationEditMode;
  readonly onEditClick: () => void;
  readonly canDelete?: boolean;
  readonly onDelete?: () => void;
  readonly isDeleting?: boolean;
}

export const CompensationHeader = ({
  breadcrumbs,
  isEditMode,
  availableEditMode,
  onEditClick,
  canDelete,
  onDelete,
  isDeleting,
}: Props) => {
  const { state } = useLocation();
  const { t } = useTranslation();

  return (
    <CardHeader>
      <div className={styles.headerTitleWrapper}>
        <Link className={styles.backButton} to={(state as string) !== null ? (state as string) : `./../`}>
          <ArrowLeft />
        </Link>
        <CompensationBreadcrumbs breadcrumbs={breadcrumbs} />
      </div>
      <div className={styles.headerActions}>
        {!isEditMode && availableEditMode !== CompensationEditMode.None && (
          <EditorButtons isEditMode={isEditMode} onEditClick={onEditClick} />
        )}
        {!isEditMode && canDelete && onDelete && (
          <Button loading={isDeleting} onClick={onDelete} icon={<DeleteIcon />}>
            {t('delete')}
          </Button>
        )}
      </div>
    </CardHeader>
  );
};
